module.exports = __webpack_public_path__ + "static/img/cabinet24_14.c2a0b4cf.gif";